/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter API — Account
 * API для управления аккаунтами пользователей в HR Recruiter системе.  **Основные возможности:** - CRUD операции для аккаунтов - Фильтрация по компаниям (SaaS-архитектура) - Ролевая модель доступа  **Роли и права доступа:** - **SUPER_ADMIN**: полный доступ ко всем аккаунтам всех компаний - **OWNER**: управление аккаунтами своей компании, может управлять ADMIN - **ADMIN**: управление аккаунтами своей компании - **RECRUITER**: доступ только к своему аккаунту  **Изоляция данных:** - Каждая компания видит только своих пользователей - Автоматическая привязка к компании при создании аккаунтов 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@hrrecruiter.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://localhost:8080/api/v1".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

/**
 *
 * @export
 */
export const operationServerMap: ServerMap = {
}
